import React, { useMemo, useState, useEffect } from 'react';
import { SelectMenu } from '@cko/primitives';
import { concatenateQuery, getExamplesList, getSuggestionList, Lexer, Parser } from './utils';
import { SearchBarContent } from './SearchBarContent';
/**
 * @deprecated - This component is due to be deleted Please remove from your mfe.
 */
export const SearchBar = ({ initialQuery = '', onSearch, entriesLookup, helpUrl }) => {
    const [query, setQuery] = useState(initialQuery);
    const entries = useMemo(() => {
        const parser = new Parser(new Lexer(entriesLookup.fields, query));
        const lastTerm = parser.getLastTerm();
        return {
            examples: getExamplesList(lastTerm.term, entriesLookup.examples),
            suggestions: getSuggestionList(lastTerm, entriesLookup.suggestions),
        };
    }, [entriesLookup, query]);
    useEffect(() => {
        setQuery(initialQuery);
    }, [initialQuery]);
    const onSelect = (item, { openMenu }) => {
        if (item) {
            setQuery(concatenateQuery(query, item.value));
            openMenu();
        }
    };
    return (React.createElement(SelectMenu, { onSelect: onSelect },
        React.createElement(SearchBarContent, { onSearch: onSearch, query: query, setQuery: setQuery, entries: entries, helpUrl: helpUrl })));
};
